import { Grid, Empty } from "antd-mobile";
import { useIntl } from "react-intl";
import styled from "styled-components";
import Image from "../Image";
export default function CodeIndex({
  list,
  onClick = () => {},
  onLongClick = () => {},
}) {
  const intl = useIntl();
  let timeOutEvent = 0;
  let longClick = 0;
  const gtouchstart = (event, item) => {
    longClick = 0;
    timeOutEvent = setTimeout(() => {
      longClick = 1;
      onLongClick(item);
      event.preventDefault();
    }, 500);
  };

  const gtouchend = (event, item) => {
    clearTimeout(timeOutEvent);
    if (timeOutEvent && !longClick) {
      //点击
      //  console.log(`点击,${item.id}`)
    }
    return false;
  };

  const gtouchmove = (e, id) => {
    clearTimeout(timeOutEvent);
    timeOutEvent = 0;
    e.preventDefault();
  };

  return (
    <Grid columns={2} gap={8} style={{ paddingRight: "2px" }}>
      {(list || []).map((e, i) => (
        <Grid.Item key={e.id}>
          <Item
            onClick={() => {
              onClick(e);
            }}
            onTouchStart={(event) => {
              gtouchstart(event, e);
            }}
            onTouchMove={(event) => {
              gtouchmove(event, e);
            }}
            onTouchEnd={(event) => {
              gtouchend(event, e);
            }}
          >
            <Title>
              {new Array(e.equip.level || 0).fill("").map((e, i) => (
                <img key={i} src="/image/foot.png" width={8} alt="foot" />
              ))}{" "}
              {e.name || e.id}
            </Title>
            <ImageWrapper>
              <Image
                width="80%"
                src={e.img}
                fit="contain"
                style={{ height: "12.0rem",margin:'auto'}}
                alt={e.id}
                errorIcon={
                  <ErrorImage>
                    <Image
                      width="100%"
                      fit="contain"
                      style={{ margin: "auto" }}
                      src={"/image/equip_default.png"}
                      alt="equip_default"
                    />
                    </ErrorImage>
                }
              />
            </ImageWrapper>
            <div className="text-center">
                <Code>
                  <I src="/image/codeIndex.png" />
                  {e.id}
                </Code>
              </div>
          </Item>
        </Grid.Item>
      ))}
      {!list || !list.length ? (
        <Grid.Item span={2}>
          <Empty
            style={{ padding: "6.4rem 0" }}
            imageStyle={{ width: 128 }}
            description={intl.formatMessage({
              id: "common.no_data",
              defaultMessage: "暫無數據",
            })}
          />
        </Grid.Item>
      ) : null}
    </Grid>
  );
}

const Item = styled.div`
  /* touch-action: none; */
  height: 100%;
  min-height: 17.2rem;
  text-align: center;
  background: #ffffff;
  border: 2px solid #000000;

  /* box-shadow: 2px 1px 1px 2px ${(props) =>
    props.active ? "#000" : "#fff"}; */
  overflow: hidden;

  border-radius: 2.2rem;
  margin-bottom: 1.5rem;
  box-sizing: border-box;
`;

const ImageWrapper = styled.div`
  /* /* min-height: 8.0rem; */
  /* height: 100%; */ 
  padding-top: 1.5rem;
  min-height: 8.0rem;
  img {
    width: 100%;
  }
  .rv-image__error{
    background: none;
  }
`;

const ErrorImage = styled.div`
  font-size: 1.0rem;
  color: #000;
  text-align: center;
  align-items: center;
  /* border: 2px solid #000000;
  box-shadow: 1px 1px 1px #000;
  border-radius: 2.6rem; */
  padding: 1.5rem 2.5rem 11%;
  height: 100%;
  display: flex;
  align-items: center;
  .rv-image--block {
    height: auto;
  }


`;

const Title = styled.div`
  margin: 0 auto;
  background: #f4f5f6;
  /* border-radius: .0rem .0rem 1.0rem 1.0rem; */
  padding: .6rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.3rem;
  line-height: 1.3rem;
  color: #000000;
`;
const Code = styled.div`
  font-family: "Anybody";
  font-style: italic;
  font-weight: 500;
  font-size: 1.2rem;
  line-height: 1.2rem;
  color: ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border: 1px solid ${(props) => (props.mounted ? "#FC9043" : "#000000")};
  border-radius: 1.9rem;
  min-width: 10.0rem;
  padding: 2px 1px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 1.0rem auto 0;
  box-shadow: .05rem .05rem .0rem
    ${(props) => (props.mounted ? "#FC9043" : "#000000")};
`;

const I = styled.img`
  width: 1.4rem;
  height: 1.4rem;
  margin-right: .8rem;
`;